exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#appDrawer[data-v-bfda4ad6] {\n  overflow: hidden;\n}\n#appDrawer .drawer-menu--scroll[data-v-bfda4ad6] {\n  height: calc(100vh - 64px);\n  width: 100%;\n  overflow: auto;\n}\n.v-list__tile__content[data-v-bfda4ad6]:hover {\n  text-decoration: none;\n}", ""]);

// exports
